import Loading from '@components/v2/ui/Loading/Loading';
import { Box } from '@mui/material';
import { memo, useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useShallow } from 'zustand/react/shallow';
import useOrderBookStore from '../../../../stores/OrderBook/orderBook.store';
import { OrderBookStateEnum } from '../../../../stores/OrderBook/orderBook.types';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import { storeRepository } from '../../../store/store.repository';
import useSalesOpportunityInterceptor from '../../SalesOpportunities/useSalesOpportunityInterceptor';
import CreateNewOrderOnBook from '../../States/CreateNewOrderOnBook';
import EmptyOrderBook from '../../States/EmptyOrderBook';
import OrdersOnBook from '../../States/OrdersOnBook';

const useStyles = makeStyles()(() => ({
  root: {
    flexGrow: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarGutter: 'stable both-edges',
  },
}));

const OrderActiveMenuContent = () => {
  const [orderBookTimeline, loading, onChangeCustomer, selectedOrder] = useOrderBookStore(
    useShallow((state) => [
      state.orderBookTimeline,
      state.loading,
      state.onChangeCustomer,
      state.selectedOrder,
    ]),
  );
  const { classes } = useStyles();
  const { handleAddInterceptor, handleRemoveInterceptor } = useSalesOpportunityInterceptor();

  useEffect(() => {
    handleAddInterceptor(selectedOrder);

    const removeInterceptorOnUmount = () => {
      handleRemoveInterceptor(selectedOrder);
    };

    return removeInterceptorOnUmount;
  }, [selectedOrder]);

  const { isStore } = useApplicationContext();

  const fetchCustomer = async () => {
    const repository = storeRepository();
    const response = await repository.getOne();

    if (response.ok) {
      onChangeCustomer(response.data.customer);
    }
  };

  useEffect(() => {
    if (isStore) {
      fetchCustomer();
    }
  }, [isStore]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Loading size={20} />
      </Box>
    );
  }

  return (
    <div className={classes.root} id="order-book-container">
      {orderBookTimeline === OrderBookStateEnum.INITIAL_STATE && <EmptyOrderBook />}
      {orderBookTimeline === OrderBookStateEnum.SEARCH_CUSTOMER && <CreateNewOrderOnBook />}
      {orderBookTimeline === OrderBookStateEnum.LIST_ORDERS && <OrdersOnBook />}
    </div>
  );
};

export default memo(OrderActiveMenuContent);
